/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrivacyPolicyResponse
 */
export interface PrivacyPolicyResponse {
    /**
     * 
     * @type {string}
     * @memberof PrivacyPolicyResponse
     */
    contentHtml?: string | null;
}

/**
 * Check if a given object implements the PrivacyPolicyResponse interface.
 */
export function instanceOfPrivacyPolicyResponse(value: object): value is PrivacyPolicyResponse {
    return true;
}

export function PrivacyPolicyResponseFromJSON(json: any): PrivacyPolicyResponse {
    return PrivacyPolicyResponseFromJSONTyped(json, false);
}

export function PrivacyPolicyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrivacyPolicyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'contentHtml': json['contentHtml'] === undefined ? undefined : json['contentHtml'] === null ? null : json['contentHtml'],
    };
}

export function PrivacyPolicyResponseToJSON(json: any): PrivacyPolicyResponse {
    return PrivacyPolicyResponseToJSONTyped(json, false);
}

export function PrivacyPolicyResponseToJSONTyped(value?: PrivacyPolicyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contentHtml': value['contentHtml'],
    };
}

